module.exports = __webpack_public_path__ + "static/media/sleepy-facebook.ef2675fa.png";